import { createContext, useEffect, useReducer, useRef } from "react";
import Cookies from "js-cookie";

export const Context = createContext({});

// initial state
export const initState = {
  randomName: "",
  option: 0,
  highScore:
    Cookies.get("highScore") != null
      ? parseInt(Cookies.get("highScore"))
      : parseInt(
          localStorage.getItem("highScore")
            ? localStorage.getItem("highScore")
            : 0
        ),
  highPlayer:
    Cookies.get("highPlayer") != null
      ? Cookies.get("highPlayer")
      : localStorage.getItem("highPlayer")
      ? localStorage.getItem("highPlayer")
      : "",
  language: "nl",
  activeButton: null,
  maxOptions: 0,
  rulesToSwitch: false,
  size: { w: 0, h: 0 },
  score: 0,
  lives: 3,
  level: 1,
  time: 0,
  mode: "normal",
};

// reducer
export const reducer = (state = initState, action) => {
  if (action.type === "reset") {
    const i = { ...initState };

    delete i.size;
    delete i.highScore;
    delete i.highPlayer;

    return { ...state, ...i };
  } else if (action.type === "time") {
    return {
      ...state,
      time: state.time + action.payload,
      score: Math.round(state.score + Math.max(0, 60 - action.payload) * 18),
    };
  } else if (action.type === "final") {
    return {
      ...state,
      lives: 0,
      score: Math.round(state.score + 1000 * state.lives),
    };
  } else {
    return {
      ...state,
      [action.type]: action.payload,
    };
  }
};

export const Provider = ({ children }) => {
  const timer = useRef();
  const [admin, dispatch] = useReducer(reducer, initState);

  useEffect(() => {
    if (admin.activeButton) {
      if (timer.current) {
        clearTimeout(timer.current);
      }

      timer.current = setTimeout(
        () => dispatch({ type: "activeButton", payload: null }),
        200
      );
    }

    return () => {
      if (timer.current) {
        clearTimeout(timer.current);
      }
    };
  }, [admin.activeButton]);

  return (
    <Context.Provider value={{ admin, dispatch }}>{children}</Context.Provider>
  );
};

export default Provider;
